import AlertModal from '@/views/components/Modals/AlertModal';
import CommonModal from '@/views/components/Modals/CommonModal';
import TrailerDatabase from '@/views/pages/Savers/TrailerDatabase';
import { useState } from 'react';

const TrailerSelectionModal = ({
  selectTrailerModal,
  findTrailerToggle,
  formTrailerRequestManagement,
  status,
  setTrailerId,
  setLoadId,
  label,
}) => {
  const [trailerData, setTrailerData] = useState({
    trailerId: '',
    trailerNumber: '',
    trailerRow: '',
  });
  const [alertOpen, setAlertOpen] = useState(false);

  const handleTrailerData = ({ trailerId, trailerData }) => {
    setTrailerData({
      trailerId,
      trailerNumber: trailerData.trailerNumber,
      trailerRow: trailerData,
    });
  };

  const setTrailerValues = () => {
    if (trailerData.trailerId === '') {
      setAlertOpen(true);
      return;
    }
    const { trailerNumber, trailerId, trailerRow } = trailerData;
    formTrailerRequestManagement.setFieldsValue({
      selTrailer: trailerNumber,
    });
    setTrailerId(trailerId);
    if (label === 'Delivery Loaded') {
      setLoadId(trailerRow.loadId);
    }
    closeModal();
  };

  const onAlertConfirm = () => {
    setAlertOpen(false);
  };

  const closeModal = () => {
    findTrailerToggle();
  };

  return (
    <CommonModal
      title="Find Trailer"
      open={selectTrailerModal}
      className="w-80 h-85"
      okText="Select"
      onOk={setTrailerValues}
      onClose={closeModal}
      onCancel={closeModal}
      isCancelBtn={false}
    >
      <TrailerDatabase status={status} handleTrailerData={handleTrailerData} isModal />

      <AlertModal
        title="Alert"
        open={alertOpen}
        description="Please select a trailer to proceed."
        onOk={onAlertConfirm}
        onClose={onAlertConfirm}
      />
    </CommonModal>
  );
};

export default TrailerSelectionModal;
